import { Box, Checkbox, Label, LabeledControl, Text, TextButton } from '@zillow/constellation-10';

const listingDeclinedUrl =
  'https://help.zillowrentalmanager.com/hc/en-us/articles/4402670385299-Listing-Decline-Reason-Room-for-Rent';

type Props = {
  isRoomForRentChecked: boolean;
  isRoomForRentDisabled: boolean;
  toggleRoomForRentChecked?: (() => void) | null;
};

const RoomForRentCheckbox = ({
  isRoomForRentChecked,
  isRoomForRentDisabled,
  toggleRoomForRentChecked = null,
}: Props) => (
  <Box css={{ paddingBlock: '200' }} data-testid="RoomForRentCheckbox">
    <Box css={{ display: 'flex' }}>
      <LabeledControl
        controlId="LabeledControl-roomForRent"
        label={<Label>This is a room for rent with a shared living space</Label>}
        control={<Checkbox checked={isRoomForRentChecked} onChange={() => toggleRoomForRentChecked?.()} />}
        disabled={isRoomForRentDisabled}
      />
    </Box>

    {isRoomForRentChecked && (
      <Text data-testid="RR-Notice" textStyle="body-sm">
        Your room for rent listing will be posted on Zillow and HotPads.&nbsp;
        <TextButton textStyle="body-sm" asChild>
          <a href={listingDeclinedUrl} rel="noreferrer" target="_blank">
            Learn more.
          </a>
        </TextButton>
      </Text>
    )}
  </Box>
);

export default RoomForRentCheckbox;
